import { useMemo } from "react"

import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { isVerified } from "modules/ClientAuthorization/common/utils"
import { Sizes } from "components/Avatar/interfaces"
import { NonImgAvatar } from "components/Avatar"

interface UserPictureProps {
    className?: string
    size: Sizes
    isAdaptive?: boolean
    isInverted?: boolean
    isMenu?: boolean
}

export function UserAvatar({ className, size, isAdaptive, isInverted, isMenu }: UserPictureProps) {
    const [{ isVerified: verified, userAccount }] = useClientContext()
    const name = useMemo(() => {
        if (isVerified(userAccount)) {
            return userAccount.name || userAccount.email
        }
        return ""
    }, [verified])

    return (
        <NonImgAvatar
            size={size}
            className={className}
            isAdaptive={isAdaptive}
            isInverted={isInverted}
            isMenu={isMenu}
        >
            {name}
        </NonImgAvatar>
    )
}
